import React from 'react';
import { kindLabel } from '../../lib/trajectory-record';

/**
 * One ledger row: index, kind badge, preview. Deliberately no duration or token
 * columns — they belong to the inspector, so the preview gets the width. Fixed
 * height (38px, set in CSS) is what lets the window hook stay this simple.
 */
export default function TrajectoryRow({ rec, selected, onSelect }) {
  return (
    <div
      className={
        'traj-row' +
        (selected ? ' traj-row-selected' : '') +
        (rec.is_error ? ' traj-row-error' : '')
      }
      role="row"
      aria-rowindex={rec.seq + 1}
      aria-selected={selected}
      tabIndex={0}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); onSelect(rec); }
      }}
      onClick={() => onSelect(rec)}
    >
      <span className="traj-index">{rec.seq}</span>
      <span className={`traj-kind traj-kind-${rec.kind}`}>{kindLabel(rec.kind)}</span>
      <span className="traj-preview" style={{ paddingLeft: rec.depth * 18 }}>
        <span className="traj-label">{rec.label}</span>
        <span className="traj-text">{rec.preview}</span>
      </span>
    </div>
  );
}
